export default __webpack_public_path__ + "static/media/madhushalini.46192a03.jpg";